import { AppContext } from "@components/features/appContext/AppContext";
import Icon from "@components/primitives/icon/Icon";
import Layout from "@components/primitives/layout/Layout";
import { appPath } from "@routes/app";
import { createTitle } from "@utils/config";
import { translation } from "@utils/translation";
import { useContext } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

type Props = {
  error: number;
  errorInfo?: string;
};

const ErrorPage = ({ error, errorInfo }: Props) => {
  const { language } = useContext(AppContext);
  if (error === 404) {
    errorInfo = translation(language).general.error.pageNotFound;
  }

  return (
    <Layout>
      <div className="h-screen w-screen flex flex-col gap-10 justify-center items-center bg-primary">
        <Helmet>
          <title>{createTitle(`Error ${error}`)}</title>
        </Helmet>
        <Icon
          className="md:h-[175px] h-[125px] text-yellow-500"
          icon="warning"
        />
        <div className="flex flex-col justify-center items-center gap-2 text-center px-5 ">
          <h1 className="text-primary font-bold text-4xl">{error}</h1>
          <h3 className="text-secondary text-xl">{errorInfo}</h3>
          <Link
            to={appPath.default}
            className="m-5 rounded bg-blue-500 hover:bg-blue-700 text-white p-2"
          >
            {translation(language).general.text.backToHomePage}
          </Link>
        </div>
      </div>
    </Layout>
  );
};

export default ErrorPage;
